export const AUTO_ADVANCE_DELAY_MS = 500;
